<ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
            size="default"
            color="#2f9cf2"
            type="line-scale-pulse-out"
            [name]="spinnerName"
            [fullScreen]="false">
            <p style="color:white" >Import Roster... </p>
</ngx-spinner>
<div class="text-center p-mt-5">
  <h3>Please make sure you uploaded the roster excel file to data/[local|preview|prod]/LegacyData folder. </h3>
</div>
<div class="text-center p-mt-5">
  <button pButton pRipple label="Reset  Roster" class="p-button p-mr-2" icon="fas fa-file-import" type="button" (click)="resetRoster()"></button>
  <button pButton pRipple label="Import Roster (.xlsm)" class="p-button p-mr-2" icon="fas fa-file-import" type="button" (click)="importRoster()"></button>
  <button pButton pRipple label="Import Roster (.csv)" class="p-button" icon="fas fa-file-import" type="button" (click)="importRosterFromCsvFile()"></button>
</div>

<p-toast position="top-right"></p-toast>